import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { BookingService } from '../service/booking.service';
import { BookingImmersionInfo } from '../booking-immersion-info';
import { InternationalPhoneNumberValidator } from '../validator/international-phone-number-validator';
import { EmailAddressValidator } from '../validator/email-address-validator';
import { ToastMessageService } from '../toast-message.service';
import { SchoolContact } from '../school-contact';
import { SchoolContactType } from '../school-contact-type';
import { ApiError } from '../api-error';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-edit-booking-immersion',
  templateUrl: './edit-booking-immersion.component.html',
  styleUrls: ['./edit-booking-immersion.component.css']
})
export class EditBookingImmersionComponent implements OnInit {

  immersionForm: FormGroup;
  selectedSchoolContacts: SchoolContact[] = [];
  schoolContactOptions: SelectItem[] = [];
  schoolContactTypes: SchoolContactType[] = [];

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private bookingService: BookingService,
    private toastService: ToastMessageService
  ) {
    this.immersionForm = builder.group({
      programmeName: null,
      programmeDetail: null,
      localCoordinatorName: null,
      localCoordinatorPhone: [null, InternationalPhoneNumberValidator],
      localCoordinatorSecondPhone: [null, InternationalPhoneNumberValidator],
      localCoordinatorEmail: [null, EmailAddressValidator],
      activityCenterName: null,
      activityCenterAddress: null,
      activityCenterEmail: [null, EmailAddressValidator],
      activityCenterPhone: [null, InternationalPhoneNumberValidator],
      selectedContact: null,
      contactForms: new FormArray([])
    });
   }

  ngOnInit(): void {
    let booking = this.bookingService.booking;
    if(booking.immersionInfo){
      let info = booking.immersionInfo;
      this.immersionForm.get("programmeName")!.setValue(info.programmeName);
      this.immersionForm.get("programmeDetail")!.setValue(info.programmeDetail);
      this.immersionForm.get("localCoordinatorName")!.setValue(info.localCoordinatorName);
      this.immersionForm.get("localCoordinatorPhone")!.setValue(info.localCoordinatorPhone);
      this.immersionForm.get("localCoordinatorSecondPhone")!.setValue(info.localCoordinatorSecondPhone);
      this.immersionForm.get("localCoordinatorEmail")!.setValue(info.localCoordinatorEmail);
      this.immersionForm.get("activityCenterName")!.setValue(info.activityCenterName);
      this.immersionForm.get("activityCenterAddress")!.setValue(info.activityCenterAddress);
      this.immersionForm.get("activityCenterEmail")!.setValue(info.activityCenterEmail);
      this.immersionForm.get("activityCenterPhone")!.setValue(info.activityCenterPhone);
      if(booking.immersionInfo.schoolContactList){
        this.selectedSchoolContacts = booking.immersionInfo.schoolContactList;
      }
    }

    this.httpService.getSchoolContacts(booking.school.id!).subscribe(res => {
      for(let contact of res){
        this.schoolContactOptions.push({label: contact.name + ", " + contact.schoolContactType.name, value: contact});
      }
    });
    this.httpService.getSchoolContactTypes().subscribe(res => {
      this.schoolContactTypes = res;
    });
  }

  submit() {
    if(this.immersionForm.invalid){
      return;
    }
    let immersionInfo = this.bookingService.booking.immersionInfo;
    let formValue = this.immersionForm.value;
    if (!immersionInfo || !immersionInfo.id) {
      let newImmersionInfo = new BookingImmersionInfo(
        formValue.programmeName,
        formValue.programmeDetail,
        formValue.localCoordinatorName,
        formValue.localCoordinatorPhone,
        formValue.localCoordinatorSecondPhone,
        formValue.localCoordinatorEmail,
        formValue.activityCenterName,
        formValue.activityCenterAddress,
        formValue.activityCenterEmail,
        formValue.activityCenterPhone,
        this.selectedSchoolContacts
      );
        immersionInfo = newImmersionInfo;
    } else {
      immersionInfo.programmeName = formValue.programmeName;
      immersionInfo.programmeDetail = formValue.programmeDetail;
      immersionInfo.localCoordinatorName = formValue.localCoordinatorName;
      immersionInfo.localCoordinatorPhone = formValue.localCoordinatorPhone;
      immersionInfo.localCoordinatorSecondPhone = formValue.localCoordinatorSecondPhone;
      immersionInfo.localCoordinatorEmail = formValue.localCoordinatorEmail;
      immersionInfo.activityCenterName = formValue.activityCenterName;
      immersionInfo.activityCenterAddress = formValue.activityCenterAddress;
      immersionInfo.activityCenterEmail = formValue.activityCenterEmail;
      immersionInfo.activityCenterPhone = formValue.activityCenterPhone;
      immersionInfo.schoolContactList = this.selectedSchoolContacts;
    }

    let contactFormArray = this.contactFormArray;
    for(let form of contactFormArray.controls){
      let contact = new SchoolContact(
        form.value.contactType,
        form.value.contactName,
        form.value.contactEmail,
        form.value.contactPhoneNumber
      );
      immersionInfo.schoolContactList.push(contact);
    }
    this.httpService.putBookingImmersionInformation(immersionInfo, this.bookingService.booking.id!).subscribe(res => {
      this.bookingService.booking.immersionInfo = res;
      this.toastService.addSuccess("Success", "Immersion information updated");
      this.immersionForm.controls["contactForms"] = new FormArray([]);
      this.bookingService.sendingUpdateRequest = false;
    }, error => {
      let apiError = new ApiError(error);
      this.toastService.addError("Error", apiError.message);
      this.bookingService.sendingUpdateRequest = false;
    });
  }

  contactOptionChange(){
    let selectedContact = this.immersionForm.value.selectedContact;
    if(!selectedContact){
      return;
    }
    if(!this.hasSameContact(selectedContact)){
      this.selectedSchoolContacts.push(selectedContact);
    }
    this.immersionForm.get("selectedContact")!.setValue(null);
  }

  hasSameContact(element: SchoolContact){
    for(let contact of this.selectedSchoolContacts){
      if(contact.id === element.id){
        return true;
      }
    }
    return false;
  }

  deleteContact(contact: SchoolContact){
    this.selectedSchoolContacts.splice(this.selectedSchoolContacts.indexOf(contact), 1);
  }
  addSchoolContactForm(){
    let contactFormArray = this.contactFormArray;
    contactFormArray.push(this.builder.group({
        contactType: [null, Validators.required],
        contactName: null,
        contactEmail: [null, EmailAddressValidator],
        contactPhoneNumber: [null, InternationalPhoneNumberValidator]
    }));
  }

  get contactFormArray(){
    return this.immersionForm.controls["contactForms"] as FormArray;
  }

  deleteContactForm(form: any){
    let formArray = this.contactFormArray;
    let index = formArray.controls.indexOf(form);
    if(index != -1){
      formArray.controls.splice(index, 1);
    }
  }
}